var _path, _path2, _path3, _circle, _circle2, _circle3, _g, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 13,
    fill: "none",
    viewBox: "0 0 11 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CE4444",
    d: "m4.651 8.066 1.205.696L3.41 13l-.702-1.566 1.944-3.368Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#983535",
    d: "m4.651 8.066-1.205-.695L1 11.609l1.707-.175 1.944-3.368Zm1.719 0-1.205.696L7.612 13l.702-1.566L6.37 8.066Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CE4444",
    d: "m6.37 8.066 1.205-.695 2.447 4.238-1.708-.175L6.37 8.066Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.473,
    cy: 5.148,
    r: 4.648,
    fill: "url(#a)",
    stroke: "#765C00"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.474,
    cy: 5.148,
    r: 3.238,
    fill: "#A88300"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 7,
    height: 7,
    x: 2,
    y: 2,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.647,
    cy: 5.494,
    r: 3.246,
    fill: "#C28B37"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.474,
    cy: 5.148,
    r: 3.246,
    fill: "#C09525"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "m2.078 2.89.644 1.4 1.288.176-.884 1.078.24 1.547-1.288-.7-1.288.7.243-1.547-.887-1.078 1.288-.175.644-1.4Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 5.473,
    x2: 5.473,
    y1: 1,
    y2: 9.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 2.078,
    x2: 2.078,
    y1: 2.89,
    y2: 7.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFCDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE896"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal);
export default __webpack_public_path__ + "static/media/medal.a0b84d876b5a45271c6681f9f3c1ea4e.svg";
export { ForwardRef as ReactComponent };